<template>
  <b-container fluid>
    <b-row class="mb-4">
      <b-col md="2">
        <b-form-select
          id="select-dealer"
          v-model="selectedDealer"
          :options="dealers"
          value-field="id"
          text-field="name"
        >
        <template #first>
          <b-form-select-option :value="null" disabled>Выберите дилера</b-form-select-option>
        </template>
        </b-form-select>
      </b-col>
      <b-col md="3">
        <b-form-select
          id="select-client"
          v-model="selectedClient"
          :options="dealerClients"
          value-field="id"
          text-field="name"
        >
        <template #first>
          <b-form-select-option :value="null" disabled>Выберите организацию</b-form-select-option>
        </template>
        </b-form-select>
      </b-col>
      <b-col md="5">
        <div class="d-flex align-items-center">
          <a-month-picker
            class="mr-3"
            size="large"
            v-model="dateStart"
            format="MM/YYYY"
            @change="changeDateStart"
            placeholder="Месяц с"/>
          <a-month-picker
            class="mr-3"
            size="large"
            v-model="dateEnd"
            format="MM/YYYY"
            @change="changeDateEnd"
            placeholder="Месяц по"/>
          <b-button
            :disabled="!dateStart || !selectedDealer || !selectedClient"
            type="button"
            variant="success"
            class="text-center action-button mr-3"
            @click="loadReport()">Загрузить отчет
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="8" v-if="isSuperUserDealer()" class="mt-3">
        <b-form-group label="Список доступных серверов:" class="mb-1">
          <b-form-radio-group
            id="radio-group-1"
            v-model="selectedServer"
            :options="servers"
            value-field="server_alias"
            text-field="server_name"
            disabled-field="disabled"
            @change="serverCheck"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="9" class="mt-3 d-flex">
        <b-button
          :disabled="!reportItems || reportItems.length == 0"
          class="ml-auto"
          @click="downloadReportExcel">Выгрузить в Excel</b-button>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="9" sm="9" class="mb-2">
        <b-table
          hover
          striped
          show-empty
          responsive
          id="data_table"
          :fields="fields"
          :items="reportItems"
          :busy="isBusy"
          :current-page="currentPage"
          :per-page="perPage"
          class="data_table_report mt-3 blue"
          empty-text="Нет данных в таблице"
          empty-filtered-text="Нет данных по вашему запросу">

          // загрузчик
          <div slot="table-busy" class="text-center text-secondary my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Загрузка...</strong>
          </div>

          <template v-slot:cell(period)="data">
            <div class="td_wrapper">
              <p class="normal">
                {{data.item.month}}.{{data.item.year}}
              </p>
            </div>
          </template>

        </b-table>

        <div class="main-footer">
          <b-form inline>
            <label class="mr-3">Показать</label>
            <b-form-select :options="pageOptions" v-model="perPage" @change="saveOptionSelected"/>
          </b-form>
          <b-pagination align="center"
                        prev-text="&lt;"
                        first-text="&lt;&lt;"
                        next-text="&gt;"
                        last-text="&gt;&gt;"
                        :total-rows="totalRows"
                        :per-page="perPage"
                        v-model="currentPage"
                        class="my-6">
          </b-pagination>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'ReportActiveUsers',
  components: {},
  data () {
    return {
      fields: [
        { key: 'name', label: 'Логин', sortable: false },
        { key: 'package_count', label: 'Количество пакетов', sortable: false },
        { key: 'package_origin', label: 'Где подан пакет', sortable: false },
        { key: 'period', label: 'Период', sortable: false }
      ],
      currentPage: 1,
      totalRows: null,
      perPage: 10,
      pageOptions: [10, 20, 50],
      pageOptionSelected: 10,
      dateStart: null,
      dateEnd: null,
      selectedServer: null,
      dateForReport: {
        dateStart: null,
        dateEnd: null,
        dateString: null
      },
      selectedDealer: null,
      selectedClient: null,
      packageStatistic: null
    }
  },
  watch: {
    selectedDealer (val) {
      if (val) {
        this.getDealerClients({ id: val })
        this.selectedClient = null
      } else {
        this.selectedClient = null
      }
    }
  },
  mounted () {
    this.selectedServer = this.servers[0].server_alias
    this.getDealers(this.selectedServer)
  },
  methods: {
    ...mapActions({
      getActiveUsersReportData: 'reports/getActiveUsersReportData',
      loadActiveUsersReportDataXlsx: 'reports/loadActiveUsersReportDataXlsx',
      getDealerClients: 'dealers/getDealerClients',
      getDealers: 'reports/getDealers'
    }),
    ...mapMutations({
      setReportItems: 'reports/setReportItems'
    }),
    isSuperUserDealer () {
      let hasRights = this.userInfo.rights.filter(item => {
        return item === 'dealer_users'
      })

      if (hasRights.length === 0) {
        hasRights = this.userInfo.rights.filter(item => {
          return item === 'support'
        })
      }
      return (hasRights.length > 0)
    },
    serverCheck () {
      this.getDealers(this.selectedServer)
      this.selectedDealer = null
      this.selectedClient = null
    },
    saveOptionSelected (event) {
      this.pageOptionSelected = event
    },
    downloadReportExcel () {
      this.loadActiveUsersReportDataXlsx({
        date: this.dateForReport,
        org_id: this.getOrgId,
        dealer_id: this.selectedDealer,
        client_id: this.selectedClient,
        piportal_alias: this.selectedServer
      })
    },
    loadReport () {
      this.getActiveUsersReportData({
        date: this.dateForReport,
        org_id: this.getOrgId,
        dealer_id: this.selectedDealer,
        client_id: this.selectedClient,
        piportal_alias: this.selectedServer
      })
    },
    changeDateStart (value) {
      this.dateStart = value
      if (value) {
        this.dateForReport.dateStart = +this.dateStart.toDate().getFullYear() * 12 + (+this.dateStart.toDate().getMonth() + 1)
        this.dateForReport.dateString = (this.dateStart.toDate().getMonth() + 1) + '_' + this.dateStart.toDate().getFullYear()
        this.selectedMonth = this.dateStart.toDate().getMonth() + 1
        this.selectedYear = this.dateStart.toDate().getFullYear()
      } else {
        this.dateForReport.dateStart = null
        this.dateForReport.dateString = null
        this.selectedMonth = null
        this.selectedYear = null
      }
    },
    changeDateEnd (value) {
      this.dateEnd = value
      if (value) {
        this.dateForReport.dateEnd = +this.dateEnd.toDate().getFullYear() * 12 + (+this.dateEnd.toDate().getMonth() + 1)
      } else {
        this.dateForReport.dateEnd = null
      }
    }
  },
  computed: {
    ...mapState(
      {
        isBusy: state => state.packageStatistic.isBusy,
        dealers: state => state.reports.dealers,
        dealerClients: state => state.dealers.dealerClients,
        reportItems: state => state.reports.reportItems,
        userInfo: state => state.authorization.userInfo
      }
    ),
    getOrgId () {
      return JSON.parse(localStorage.getItem('citadelUserInfo')).company.org_id
    },
    servers () {
      const arr = []
      this.userInfo.piportals.map(item => {
        arr.push({ server_name: item.name, server_alias: item.alias })
      })
      return arr
    }
  },
  destroyed () {
    this.setReportItems({ data: [] })
  }
}
</script>

<style lang="scss" scoped>
  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .input-group {
    .form-control:not(:last-child), .custom-select:not(:last-child) {
      border-top-right-radius: 0.25rem;
      border-bottom-right-radius: 0.25rem;
      font-size: 14px;
      height: 40px;
    }
  }

  .action-button {
    height: 40px;
    width: 170px;
  }

  .totals {
    font-size: 14px;
    border-bottom: 1px solid #dee2e6;
    padding: 5px;
  }

  .container_search-close {
    position: absolute;
    right: 11px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
    &:hover {
      border-radius: 50%;
      background-color: #acacac;
      span {
        color: #fff;
      }
    }
    .search-close {
      font-size: 18px;
      color: #acacac;
      cursor: pointer;
      line-height: 18px;
      width: 18px;
      text-align: center;
      margin-bottom: 2px;
    }
  }

  .filtered-items-number {
    font-size: 14px;
  }

  .details-wrapper {
    width: 100%;
    display: inline-block;
    position: relative;
    .details-wrapper-count {
      position: absolute;
      right: 8px;
    }
  }

  .button-end {
    display: flex;
    justify-content: flex-end;
  }

  .download-report {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      color: #6c6c6c;
    }
  }

  @media screen and (min-width: 320px) and (max-width: 1023px) {
    #data_table {
      font-size: 10px;
    }
    .total {
      font-size: 10px;
    }
    .total-wrapper {
      font-size: 10px;
    }
    .select-total {
      font-size: 10px;
    }
    .main-footer {
      font-size: 10px;
    }
    .custom-select {
      font-size: 10px;
    }
    .option-count {
      position: absolute;
      right: 0;
      top: 3px;
    }
    .option-text {
      position: relative;
      top: 3px;
    }
    .download-details {
      font-size: 14px;
      color: #78909c;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1439px) {
    .total {
      font-size: 14px;
    }
    .total-wrapper {
      font-size: 14px;
    }
    .select-total {
      font-size: 14px;
    }
    .option-count {
      position: absolute;
      right: 0;
    }
  }

  @media screen and (min-width: 1440px) {
    .option-count {
      position: absolute;
      right: 0;
    }
  }

  .badge {
    font-size: 87%;
  }
</style>
